import "../Dialogs/commondialogs.scss";
import { type FC, useState } from "react";
import moment from "moment";
import { useShopfrontDispatch } from "../../_Bootstrap/hooks";
import { hideDialog } from "../../Actions/Dialogs/DialogActions";
import { saveFile } from "../../Utilities/Generic/Files";
import FontAwesomeLight from "../../Utilities/Platform/FontAwesome/FontAwesomeLight";
import Button from "../Buttons/Button";
import PopupManager from "../Popups/PopupManager";
import { exportLogs, exportLogsAsString } from "./ExportLogs";

export const ExportLoggingDialog: FC = () => {
    const dispatch = useShopfrontDispatch();

    const [ loading, setLoading ] = useState(false);
    const [ download, setDownload ] = useState(false);

    const onCancel = () => {
        dispatch(hideDialog());
    };

    const onExport = async (): Promise<void> => {
        setLoading(true);

        try {
            const useFileSystemAPI = typeof window.showDirectoryPicker === "function";

            // Get the data that is used for the export's filenames
            const date = moment().format("Y-MM-DD_HH_mm_ss");
            const location = window.location;
            const vendor = location.host.split(".")[0];

            // Prepare file system access handlers
            let logFile;

            if(useFileSystemAPI) {
                const handle = await window.showDirectoryPicker();

                logFile = await handle.getFileHandle(`shopfront-${vendor}-${date}.log`, {
                    create: true,
                });
            }

            // Check to see fi the new API can be used
            if(useFileSystemAPI && logFile) {
                const logWritable = await logFile.createWritable();

                console.log("Starting the log export (stream)");
                await exportLogs(entries => {
                    return logWritable.write(`${entries.join("\r\n")}\r\n`);
                });

                await logWritable.close();
                console.log("Finished the log export (stream)");
            } else {
                console.log("Starting the log export (download)");
                saveFile(await exportLogsAsString(), "text/plain", `shopfront-${vendor}-${date}`, ".log");
                console.log("Finished the log export (download)");
            }
        } catch(e) {
            PopupManager.error("Failed exporting the diagnostic information");
            console.error("Unable to export diagnostic information", e);

            setLoading(false);
            setDownload(true);
        }

        setLoading(false);
        setDownload(true);
    };

    if(download) {
        return (
            <div>
                <p>We&#39;ve saved your diagnostics.</p>
                <FontAwesomeLight icon="download" />
                <div className="buttons">
                    <Button
                        type="button"
                        classes={[ "button-cancel" ]}
                        onClick={onCancel}
                    >
                        Close
                    </Button>
                </div>
            </div>
        );
    }

    if(loading) {
        return (
            <div>
                <p>We&#39;re preparing your download...</p>
                <FontAwesomeLight icon="spinner-third" spin />
            </div>
        );
    }

    return (
        <>
            <div>
                <p>Export the Shopfront logging history to help us diagnose errors.</p>
            </div>
            <div className="buttons">
                <Button
                    classes={[ "button-cancel" ]}
                    onClick={onCancel}
                >
                    <FontAwesomeLight icon="ban" />Cancel
                </Button>
                <Button
                    classes={[ "button-primary" ]}
                    onClick={onExport}
                >
                    <FontAwesomeLight icon="download" />Export
                </Button>
            </div>
        </>
    );
};
